/* eslint-disable require-yield */
import { all } from 'redux-saga/effects';
function* helloSaga() {
  // console.log('Hello Sagas!');
}

export default function* rootSagaApp() {
  yield all([helloSaga]);
}
